<script>
  import AccordionGroup from "../Components/Accordion/AccordionGroup.svelte";
  import AccordionItem from "../Components/Accordion/AccordionItem.svelte";

  export let title, parentId;
</script>

<AccordionGroup {title} {parentId}>
  <AccordionItem>
    <div slot="header">
      If I update my Renewal Address online will it update the mailing address
      for my renewal?
    </div>
    <div slot="content">Yes</div>
  </AccordionItem>
  <AccordionItem>
    <div slot="header">How long does it take to process an address change?</div>
    <div slot="content">The address will be updated immediately.</div>
  </AccordionItem>
</AccordionGroup>
